import React from 'react'
import {Link} from 'react-router-dom'

const PhotosFooter = () => {
  return (
  <footer className="site-footer photos-footer-links">
   
  <div className='photos-footer-links-container'>
    
    <div  >
      <p>TeluguOne Services</p>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/live/"> » Tv Channel</a>
      <a target="_blank" rel="noopener noreferrer" href="http://www.kidsone.in/"> » Kids One</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/shortfilms"> » Short Films</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/tonegreetings"> » Greetings</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/health"> » Health</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguonefoundation.in/index.html"> » Charity</a>
    </div>  

    <div>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/tmdb"> » Cinema</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/comedy"> » Comedy</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/toneshop"> » Shopping</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.mypodcastone.com/"> » MyPodcastOne</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.freshersadda.com/"> » Fresher Jobs</a>
    </div>  

    <div>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/news"> » News</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/movies"> » Movies</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/toneastrology"> » Astrology</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/games/"> » Games</a>
    </div>   

    <div>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguoneradio.com/"> » Web Radio (Tori)</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/videos"> » Videos</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/devotional"> » Bhakti</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/vanitha"> » Vanitha</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/nri"> » Nri Corner</a>
    </div>  

    <div >
      <p>TeluguOne For Your Business</p>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/advertises/index.html"> » Ad Tariff</a>
      
      <p>TeluguOne Services</p>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/helpdir/index.jsp?filename=/aboutus/aboutus.htm"> » About TeluguOne</a>
    </div>   

  </div>
 <div style={{display:"flex",flexDirection:"row"}}><div className='photos-footer-middle-container align-items-start'>
    <a target="_blank" rel="noopener noreferrer" href="https://monitor6.sucuri.net/m/verify/?r=9681bb810d8920cf5f92131176fe958c1e7815f524">
      <img src="http://teluguone.com/home_images/sukuri_badge1.png" alt="sucuri_img" />
    </a>

    <a target="_blank" rel="noopener noreferrer" href="https://workspaceupdates.googleblog.com/2023/04/new-community-features-for-google-chat-and-an-update-currents.html">
      Link Exchange With TeluguOne || Find us on Google
    </a>
  </div>

  <div className='photos-footer-middle-container align-items-end'>
    <p>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/helpdir/">Help | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/sitemap.html">Site Map | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/sitetour/">Site Tour | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/recommend/">Recommend | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/chklogin.jsp?url=/reminder/index.jsp">Reminder | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/helpdir/index.jsp?filename=faqs/faq.htm">FAQ | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/helpdir/index.jsp?filename=contactinfo/contactinfo.htm">Contact Info | </a>
      <a target="_blank" rel="noopener noreferrer" href="https://teluguone.com/fb/feedback.jsp?feature=HomePage">Feedback</a>
    </p>

    <p>2000 - <span id="year">{new Date().getFullYear()}</span>, TeluguOne.com, All rights reserved.</p>
    <h2>KEYWORD TELUGU</h2>
  </div></div>
  

  <div className='photos-footer-desclaimer'>
    <p>
      Disclaimer: All content included on this TeluguOne.com Portal including text, graphics, images, videos and audio clips, is the property of ObjectOne Information Systems Ltd. or our associates, and protected by copyright laws. The collection, arrangement and assembly of all content on this portal/ related channels is the exclusive property of ObjectOne Information Systems Ltd. or our associates and protected by copyright laws.
    </p>
  </div>

</footer>
  )
}

export default PhotosFooter;
